// extracted by mini-css-extract-plugin
module.exports = {"simpleHeader":"SimpleHeader-module--simple-header--1sRBV","back":"SimpleHeader-module--back--3QPFh","switch":"SimpleHeader-module--switch--1FxTs"};